<div div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">

  <div class="full-grow-no-shrink-no-basis" *ngIf="!(fieldDefinition?.metaData?.UseEllipsisLibrary)"
       [ngClass]="fieldDefinition?.metaData?.HideEllipsis === 'true' ? '' : 'grid-cell-ellipsis'"
       title="{{item.cells[fieldDefinition.key] ? (item.cells[this.fieldDefinition.key].value?.toolTip ? item.cells[this.fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
       [innerHTML]="item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].displayText | apiColourHtml) : '' | sanitizeHtml">
  </div>

  <Button
    *ngIf="item.cells[fieldDefinition.key + '_HasDetailText'] && item.cells[fieldDefinition.key + '_HasDetailText'].displayText === 'Yes'"
    class="note-cell-arrow" (click)="openNote()">
    <div class="arrow-left"></div>
  </Button>
</div>
